import axios from 'axios';

export type ResursPayB2CPayload = {
    payment_method: string;
    id_number: string;
    customer_email: string;
    name: string;
    street_address: string;
    care_of: string;
    postal_code: string;
    city: string;
};

export type ResursPayB2BPayload = {
    payment_method: string;
    customer_email: string;
    name: string;
    street_address: string;
    care_of: string;
    postal_code: string;
    city: string;
};

export type ResursPayResponse = {
    url: string;
};

const getBaseUrl = () => import.meta.env.VITE_API_BASE_URL ?? '';

export async function resursPay(
    invoiceId: string,
    payload: ResursPayB2CPayload | ResursPayB2BPayload
): Promise<string> {
    const { data } = await axios.post<ResursPayResponse>(
        `${getBaseUrl()}web/invoice/${invoiceId}/pay/`,
        payload
    );
    return data.url;
}
